import {Attrs, EventListeners, MinzeElement, Reactive} from "minze";
import {Locale} from "../../modules/locale";

export interface TjSearchResultCard {
  data: string;
  hover: boolean;
}

export class TjSearchResultCard extends MinzeElement {
  attrs: Attrs = [["data"]];
  reactive: Reactive = [["hover", false]];
  cardData: any = null;
  lang = Locale.language;

  onReady(): void | Promise<void> {
    this.cardData = JSON.parse(decodeURIComponent(this.data));
    this.rerender();
  }

  static observedAttributes = ["data"];

  onAttributeChange = (name: string, oldValue: string, newValue: string) => {
    if (name === "data" && oldValue !== newValue) {
      this.cardData = JSON.parse(decodeURIComponent(newValue));
      this.rerender();
    }
  };

  html = () => /* html */ `
    <a class="result-card" href="${this.cardData?.urlConstruct?.[this.lang]}">
      <div class="result-card-body">
        <p class="result-card-theme">${this.cardData?.category?.iv?.[0]?.data?.title?.[this.lang]}</p>
        <h3>${this.cardData?.title?.[this.lang]}</h3>
      </div>
      <div class="result-card-footer">
        ${!!this.cardData?.type ? `<div class="result-card-tag">${this.cardData?.type?.[this.lang]}</div>` : ''}
        <tj-result-card-next-icon ${this.hover ? `data-color="#FFF"` : ``}></tj-result-card-next-icon>
      </div>
      <div class="bg-effect"></div>
    </a>
  `;

  css = () => `
    :host {
    }
    .result-card {
      background: #F1F1C4;
      border-width: 4px 4px 14px 4px;
      border-style: solid;
      border-color: #068FC3;
      border-radius: 14px;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      color: inherit;
      text-decoration: inherit;
      padding: 16px;
      transition: .2s;
      position: relative;
    }
    .result-card:hover .result-card-theme {
      color: #fff;
    }
    .result-card:hover h3 {
      color: #fff;
    }
    .result-card:hover .result-card-tag {
      border-color: white;
      color: #fff;
    }
    .bg-effect {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      top: 100%;
      background: #068FC3;
      transition: 0.3s;
    }
    .result-card:hover .bg-effect {
      top: 0;
    }
    .result-card-theme {
      font-weight: 700;
      font-size: 11px;
      line-height: 150%;
      text-transform: uppercase;
      color: #068FC3;
      margin: 0;
    }
    .result-card-tag {
      margin: 0;
      border: 1px solid #068FC3;
      border-radius: 8px;
      padding: 4px 8px;
      font-weight: 700;
      font-size: 11px;
      line-height: 150%;
      text-transform: uppercase;
      color: #068FC3;
    }
    h3 {
      font-weight: 500;
      font-size: 16px;
      line-height: 150%;
      color: #133762;
      margin: 2px 0 24px 0;
    }
    .result-card-footer {
      display: flex;
      justify-content: space-between;
    }
    tj-result-card-next-icon {
      width: 25px;
      height: 25px;
      margin-left: auto;
    }
    .result-card-footer, .result-card-body {
      z-index: 1;
    }
  `;

  eventListeners: EventListeners = [
    [".result-card", "mouseover", () => {this.hover = true}],
    [".result-card", "mouseout", () => {this.hover = false}]
  ];
}
